var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgHeartOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7504 1.41358C18.389 1.68663 18.9692 2.08683 19.4579 2.59133C19.9468 3.09559 20.3346 3.69431 20.5992 4.35328C20.8638 5.01226 20.9584 5.60533 21 6.43187C21 11.8621 16.2163 15.314 16 15.5C13.877 17.3256 11 19 11 19C11 19 8.12299 17.3256 6 15.5C5.78374 15.314 1 11.8621 1 6.43187C1.04159 5.60533 1.1362 5.01226 1.4008 4.35328C1.66541 3.69431 2.05324 3.09559 2.54215 2.59133C3.03082 2.08683 3.61104 1.68663 4.24964 1.41358C4.88825 1.14054 5.57273 1 6.26398 1C6.95524 1 7.63972 1.14054 8.27833 1.41358C8.91693 1.68663 9.49715 2.08683 9.98582 2.59133L11 3.63785L12.0142 2.59133C12.5029 2.08683 13.0831 1.68663 13.7217 1.41358C14.3603 1.14054 15.0448 1 15.736 1C16.4273 1 17.1118 1.14054 17.7504 1.41358Z",
    stroke: "#055d42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOpen);
export default __webpack_public_path__ + "static/media/HeartOpen.ab4ff2e7.svg";
export { ForwardRef as ReactComponent };